import { defineComponent as _defineComponent } from 'vue'
import RmpDetailsGroup from "@rmp/core/components/details/RmpDetailsGroup.vue";
import RmpDetailsItem from "@rmp/core/components/details/RmpDetailsItem.vue";
import RmpDetailsSectionTitle from "@rmp/core/components/details/RmpDetailsSectionTitle.vue";
import RmpDetailsSubheader from "@rmp/core/components/details/RmpDetailsSubheader.vue";
import RmpDetailsItemLoader from "@rmp/core/components/loaders/details/RmpDetailsItemLoader.vue";
import RmpDetailsSubheaderLoader from "@rmp/core/components/loaders/details/RmpDetailsSubheaderLoader.vue";

import { ApiEgrulLegalEntity } from "@rmp/api-gateway";
import { useI18n } from "vue-i18n-composable";

interface Props {
	details: ApiEgrulLegalEntity;
	title?: string;
	loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpLegalEntityDetails',
  props: {
    details: null,
    title: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	details: ApiEgrulLegalEntity;
	title?: string;
	loading?: boolean;
};

const { tc } = useI18n();



return { __sfc: true,tc, props, RmpDetailsGroup, RmpDetailsItem, RmpDetailsSectionTitle, RmpDetailsSubheader, RmpDetailsItemLoader, RmpDetailsSubheaderLoader }
}

})